export default __webpack_public_path__ + "static/media/about-hero-right.ed676656.png";